import {Toast} from "primereact/toast";
import {useEffect, useRef} from "react";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {Navigate, useLocation} from "react-router-dom";

import LoadingIndicator from "../component/LoadingIndicator";
import {MainFrame, MainToolbar} from "../component/MainFrame";
import {
    clearReloadError,
    selectPersistenceInitialized,
    selectPersistenceLoading,
    selectPurposePolicy,
    selectReloadError,
    selectReloadLoading,
} from "../redux/persistenceSlice";
import {useRevaDispatch} from "../redux/revaHooks";
import {useEffectRequiresValidRevaId} from "../util/hooks";
import PersistenceFinalMessage from "./object/PersistenceFinalMessage";
import SnapshotMessage from "./object/SnapshotMessage";
import OrderOverview from "./order/OrderOverview";

function PageOrder() {
    const {t} = useTranslation();
    const dispatch = useRevaDispatch();
    const loading = useSelector(selectPersistenceLoading);
    const initialized = useSelector(selectPersistenceInitialized);
    const reloadLoading = useSelector(selectReloadLoading);
    const reloadError = useSelector(selectReloadError);
    const showLoading = loading || !initialized || reloadLoading;
    const toast = useRef<Toast>(null);
    const location = useLocation();
    // #19481: Research-Abfragen haben keinen Reiter „Auftrag" (kein Zuweisen, keine Value-Order-Aktionen); die
    // Sidebar blendet ihn aus, ein direkt aufgerufenes /order führt zur Objektseite.
    const {transferAllowed} = useSelector(selectPurposePolicy);

    useEffectRequiresValidRevaId();

    // A failed reload keeps the previously loaded data intact (see reloadPersistence thunk); surface
    // the error as a toast and clear it so it only fires once.
    useEffect(() => {
        if (reloadError) {
            toast.current?.show({severity: "error", detail: t("order.revaOrder.reloadError"), life: 4000});
            dispatch(clearReloadError());
        }
    }, [reloadError, dispatch, t]);

    if (!showLoading && !transferAllowed) {
        return <Navigate to={{pathname: "/object", search: location.search}} replace />;
    }

    return (
        <MainFrame>
            <Toast ref={toast} />
            <MainToolbar title={t("order.orderData")} />
            <PersistenceFinalMessage />
            <SnapshotMessage />
            <LoadingIndicator loading={showLoading} />
            {!showLoading && <OrderOverview />}
        </MainFrame>
    );
}

export default PageOrder;
